import { render, staticRenderFns } from "./BigCommerce.vue?vue&type=template&id=5f1fff7f"
import script from "./BigCommerce.vue?vue&type=script&lang=ts"
export * from "./BigCommerce.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports